module.exports = "<div id=\"hide-menu\" class=\"btn-header pull-right\">\r\n        <span> <a (click)=\"onToggle()\" title=\"Collapse Menu\"><i class=\"fa fa-reorder\"></i></a> </span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/header/collapse-menu/collapse-menu.component.html
// module id = 876
// module chunks = 29